import { render } from "./CambioPass.vue?vue&type=template&id=45422dd5&ts=true"
import script from "./CambioPass.vue?vue&type=script&lang=ts"
export * from "./CambioPass.vue?vue&type=script&lang=ts"

import "./CambioPass.vue?vue&type=style&index=0&id=45422dd5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__